import React, {useEffect} from "react";
import 'components/placed_item/free_transform_styles.css'
import 'components/placed_item/free_move_styles.css'
import {auth, dbPlacedItems} from "components/firebase";
import PlacedItemView, {PlacedItemUtil} from "components/placed_item/placed_item_view";
import HTMLReactParser from "html-react-parser";
import Types from "components/editor_canvas/editor_canvas_element_types";
import EditorCanvas from "components/editor_canvas";

class PlacedItem extends React.Component {
    transforming = false;
    transform = false;
    is_full = false;
    nClick = 0;    // how many times user clicked on the item (reset on transform)
    constructor(props) {
        super(props);

        this.textContent = HTMLReactParser(props.placedItem.textOverlay.content);
        this.textContentInitial = HTMLReactParser(props.placedItem.textOverlay.content);
        this.styles = {...props.placedItem.textOverlay.styles};
        this.state = {
            placedItem: props.placedItem,
            textFocused: false
        };
        this.is_full = typeof props.placedItem.asset === "string";
        this.allow_transform_w = !props.placedItem.meta || !props.placedItem.meta.freeTransform || props.placedItem.meta.freeTransform === 'w';
        this.allow_transform_h = !props.placedItem.meta || !props.placedItem.meta.freeTransform || props.placedItem.meta.freeTransform === 'h';
    }


    onItemUpdate(pitem, {x, y, scaleX, scaleY, angle}) {
        if (x !== undefined && y !== undefined && !(pitem.meta && pitem.meta.freeze && !(scaleX || scaleY))) {
            if (this.allow_transform_h) {
                pitem.position.y = y;
            }
            if (this.allow_transform_w) {
                pitem.position.x = x;
            }
            PlacedItemUtil.positionToPercentMut(this.props.canvasRect, pitem.position);
        }

        if (scaleX !== undefined && scaleY !== undefined) {
            if (this.allow_transform_w) {
                pitem.position.scaleX = scaleX;
            }
            if (this.allow_transform_h) {
                pitem.position.scaleY = scaleY;
            }
        }
        if (angle !== undefined) {
            pitem.position.rotation = angle;
        }
        this.setState({
            placedItem: pitem
        });
        if (this.nClick !== -1) {
            this.unfocusText(this.state.placedItem);
        }
        this.nClick = -1;
        this.forceUpdate();
    }


    componentDidMount() {
        this.handleResizeListener = () => this.handleResize();
        window.addEventListener('resize', this.handleResizeListener);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.transform !== this.transform && !this.props.transform) {
            this.nClick = 0;
            this.unfocusText(this.state.placedItem);
            if (this.state.placedItem.uuid === EditorCanvas.STORY_TITLE_ID) {
                this.props.onTitleUpdate(this.state.placedItem);
            } else {
                dbPlacedItems.doc(this.state.placedItem.uuid).set(this.state.placedItem, {merge: true});
            }
        }
        this.transform = this.props.transform;
    }

    handleResize() {
        this.forceUpdate();
    }

    componentWillMount() {
        this.keyPressListener = (e) => this.onKeyPress(e);
        document.addEventListener('keydown', this.keyPressListener)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResizeListener);
        document.removeEventListener('keydown', this.keyPressListener);
    }

    transformChanged(newP) {
        let position = this.state.placedItem.position;
        if (position.x === newP.x &&
            position.y === newP.y &&
            position.rotation === newP.rotation &&
            position.width === newP.width &&
            position.height === newP.height &&
            position.scaleX === newP.scaleX &&
            position.scaleY === newP.scaleY &&
            position.zIndex === newP.zIndex) {
            return false;
        }
        this.state.placedItem.position = newP;
        return true;
    }

    textOverlayChanged(overlay) {
        let newS = overlay.styles;
        if (this.styles.fontSize === newS.fontSize &&
            this.styles.color === newS.color &&
            this.state.placedItem.textOverlay.content === overlay.content) {
            return false;
        }
        if (this.state.placedItem.textOverlay.content !== overlay.content) {
            this.state.placedItem.textOverlay.content = overlay.content;
        }
        this.styles = {...newS};
        return true;
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.transform !== this.props.transform) return true;
        return this.textOverlayChanged(this.state.placedItem.textOverlay)
            || this.transformChanged(nextProps.placedItem.position);
    }

    onItemMoveUp(pitem) {
        this.unfocusText(pitem);
        if (pitem.position.zIndex <= 1)
            return;
        pitem.position.zIndex -= 1;
        this.setState({
            placedItem: pitem
        });
        this._updatePlacedItem(pitem);
    }

    onItemMoveDown(pitem) {
        this.unfocusText(pitem);
        if (pitem.position.zIndex >= 5)
            return;
        pitem.position.zIndex += 1;
        this.setState({
            placedItems: {
                ...this.state.placedItems,
                [pitem.uuid]: pitem
            }
        });
        this._updatePlacedItem(pitem);
    }

    _updatePlacedItem(pitem) {
        if (!pitem) return;
        this.forceUpdate();
    }

    render() {
        let editProps = {};
        if (!this.props.readOnly) {
            editProps = {
                transforming: this.transforming,
                onTransformEnd: (placedItem) => this.onTransformEnd(placedItem),
                onTransformStart: (placedItem) => this.onTransformStart(placedItem),
                onClick: (e) => this.onClick(e),
                onHMirror: (placedItem) => this.onMirror(placedItem, true),
                onVMirror: (placedItem) => this.onMirror(placedItem, false),
                onUpdate: (pitem, params) => this.onItemUpdate(pitem, params),
                onDelete: (placedItem) => this.onItemDelete(placedItem),
                onMoveDown: (placedItem) => this.onItemMoveDown(placedItem),
                onTextSave: (pitem, event) => this.onTextSave(pitem, event),
                onTextChange: (pitem, event) => this.onTextChange(pitem, event),
                onMoveUp: (placedItem) => this.onItemMoveUp(placedItem)
            };
        }
        return <PlacedItemView
            {...this.props}
            {...editProps}
            placedItem={this.state.placedItem}
            textContent={this.textContent}
            textContentInitial={this.textContentInitial}
            textFocused={this.state.textFocused}
            fullTextBox={this.is_full}
        />;
    }

    onItemDelete(pitem) {
        this.unfocusText(pitem);
        if (pitem.uuid === EditorCanvas.STORY_TITLE_ID) {
            pitem = EditorCanvas.getTitlePlacedItem();
            pitem.textOverlay.content = this.textContent;
            this.props.onTitleUpdate(pitem);
            this.setState({
                placedItem: pitem
            });
            this._updatePlacedItem(pitem)
        } else {
            dbPlacedItems.doc(pitem.uuid).delete();
        }
    }

    onTransformStart(pitem) {
        this.transforming = true;
        this.transInitialPos = {...this.state.placedItem.position};
        if (!!this.props.onTransformStart) this.props.onTransformStart(pitem);
    }

    onTransformEnd(pitem) {
        this.transforming = false;
        this._updatePlacedItem(pitem);
        if (!!this.props.onTransformEnd) this.props.onTransformEnd(pitem);
    }

    static compareMaps(map1, map2) {
        var testVal;
        if (map1.size !== map2.size) {
            return false;
        }
        for (var [key, val] of map1) {
            testVal = map2.get(key);
            // in cases of an undefined value, make sure the key
            // actually exists on the object so there are no false positives
            if (testVal !== val || (testVal === undefined && !map2.has(key))) {
                return false;
            }
        }
        return true;
    }

    onMirror(pitem, horizontal) {
        this.unfocusText(pitem);
        if (horizontal) {
            pitem.position.h_mirror = !pitem.position.h_mirror;
        } else {
            pitem.position.v_mirror = !pitem.position.v_mirror;
        }
        this.setState({
            placedItem: pitem
        });
        this._updatePlacedItem(pitem);
    }

    onTextChange(pitem, event) {
        this.textContent = HTMLReactParser(event.target.innerHTML);
        // this.forceUpdate();
    }

    onTextSave(pitem, event) {
        pitem.textOverlay.content = event.target.innerHTML;
        this._updatePlacedItem(pitem);
    }

    unfocusText(pitem) {
        this.setState({
            textFocused: false
        });
        if (!!this.props.onTextFocus) this.props.onTextFocus(pitem, false);
        this.forceUpdate();
    }

    focusText(pitem) {
        this.setState({
            textFocused: true
        });
        setTimeout(() => {
            let element = document.getElementById(this.state.placedItem.uuid);
            if (!!element) {
                element.focus();
            }
        }, 200);
        console.log('focus text', pitem);
        if (!!this.props.onTextFocus) this.props.onTextFocus(pitem, true);
        this.forceUpdate();
    }

    onKeyPress(e) {
        if (this.state.placedItem.type !== Types.PLACED_TEXTBOX && this.state.placedItem.type !== Types.PLACED_TEXTBOX_FULLSCREEN) return;
        if (this.state.textFocused) return;
        if (!this.props.transform) return;
        this.focusText(this.state.placedItem);
    }

    onClick(e) {
        if (this.state.placedItem.type !== Types.PLACED_TEXTBOX && this.state.placedItem.type !== Types.PLACED_TEXTBOX_FULLSCREEN) return;
        this.nClick++;
        if (this.nClick % 2 !== 0) {
            this.focusText(this.state.placedItem);
        } else {
            this.unfocusText(this.state.placedItem);
        }
    }
}

export default PlacedItem;
